import { createRouter, createWebHistory } from 'vue-router';
import _some from 'lodash/some';

import Config from '$root/Config';
import Routes from '$router/Routes.js';
import store from '$stores/MainStore';

import {urlQueryToObject} from '../utils/urlUtils.js';

const router = createRouter({
	history: createWebHistory(),
	routes: Routes.routes,
});

// Custom browsing history tracking
router._entries = [];

router.beforeEach((to, _, next) => {
	const { meta } = Config.routes;
	Object.assign(meta, to.meta);
	document.title = meta.title;

	//check if auth token is in query params
	const params = urlQueryToObject();
	if(params['_bearer-token']) {
		store.dispatch('session/updateToken', params['_bearer-token']);
	}


	if(params['analyseDateMin'] && params['analyseDateMax']) {
		store.commit('updateAnalyseDate', [Number(params['analyseDateMin']), Number(params['analyseDateMax'])]);
	}

	if(params['analyseDateMin'] && params['analyseDateMax']) {
		store.commit('updateAnalyseDate', [Number(params['analyseDateMin']), Number(params['analyseDateMax'])]);
	}

	//check if next route is detail of own account and redirect to own account page
	if(to.name === 'UserDetail' && to.params.id === store.state.session.user.id) {
		next({name: 'Account'});
		return;
	}

	if (_some(to.matched, ({ meta }) => meta.hideForAuth)) {
		if (store.state.session.model.jwt_token) {
			next({ path: '/home' });
		} else {
			next();
		}
	} else {
		next();
	}
});

router.afterEach((to, from) => {
	const params = urlQueryToObject();
	if(params['analyseDateMin'] && params['analyseDateMax']) {
		const url = new URL(window.location.href);
		url.searchParams.delete('analyseDateMin');
		url.searchParams.delete('analyseDateMax');
		window.history.replaceState({}, document.title, url.toString());
	}

	if (!to.meta.excludeFromHistory) {
		if (from.name === to.name) {
			router._entries.pop(); // to immitate replace
		}

		router._entries.push(to);
	}

	if (router._entries.length > Config.history.max) router._entries.shift();
});

router.getPreviousEntry = function() {
	return router._entries[router._entries.length - 2];
};

router.getLastEntry = function() {
	return router._entries[router._entries.length - 1];
};

router.goBack = function(backUrl = null) {
	if (!backUrl) backUrl = Config.routes.home;

	if (router._entries.length > 1) {
		// remove last entry
		router._entries.pop();

		// get & remove last entry
		backUrl = router._entries.pop().fullPath;
	} else {
		// empty entries to clean history when it is considered empty
		// one may be present = current page (before page change)
		router._entries.length = 0;
	}

	router.push(backUrl);
};

export default router;
